export default {
  title: "Buy4Me Orders",
  subtitle: "Manage Buy4Me orders and customer requests",
  
  addNew: "Add New Order",
  createOrder: "Create Order",
  editOrder: "Edit Order",
  deleteOrder: "Delete Order",
  orderDetails: "Order Details",
  viewOrder: "View Order",
  printInvoice: "Print Invoice",
  
  // Tabs for details page
  tabs: {
    editOrder: "Edit Order",
    statusUpdate: "Status Update",
    invoice: "Invoice",
    logs: "Logs",
    summaries: "Summaries",
    coreFormFields: "Core Form Fields",
    statusManagement: "Status Management",
    invoiceManagement: "Invoice Management",
    orderHistory: "Order History",
    orderSummary: "Order Summary"
  },
  
  // Fields
  fields: {
    orderNumber: "Order Number",
    orderGroup: "Group",
    customer: "Customer",
    merchantName: "Merchant Name",
    description: "Description",
    quantity: "Quantity",
    status: "Status",
    netPrice: "Net Price",
    totalPrice: "Total Price",
    voucherValue: "Voucher Value",
    weight: "Weight",
    width: "Width",
    height: "Height",
    length: "Length",
    trackingId: "Tracking ID",
    itemPrice: "Item Price",
    servicePrice: "Service Price",
    discount: "Discount",
    extraService: "Extra Service",
    totalPaid: "Total Paid",
    netDue: "Net Due",
    merchantDeliveryFee: "Merchant Delivery Fee",
    currency: "Currency",
    date: "Date",
    address: "Address",
    address2: "Address 2",
    phone: "Phone",
    link: "Link",
    itemOptions: "Item Options",
    extendedDescription: "Extended Description",
    originCountry: "Origin Country",
    destinationCountry: "Destination Country",
    paymentType: "Payment Type",
    category: "Category",
    unitWidth: "Unit Width",
    unitHeight: "Unit Height",
    unitLength: "Unit Length",
    unitWeight: "Unit Weight",
    itemType: "Item Type",
    deliveryMode: "Delivery Mode",
    shippingCompany: "Shipping Company",
    lbTransportPrice: "LB Transport Price",
    hasShippingInsurance: "Shipment Insurance",
    dgFees: "DG Fees",
    enableDGFees: "Enable DG Fees",
    city: "City",
    localDeliveryFee: "Local Delivery Fee",
    shippingOrderNumber: "Shipping Order Number",
    refundInvoiceNumber: "Refund Invoice Number",
    reorderedId: "Reordered Id",
    refundType: "Refund Type",
    additionalCost: "Additional Cost",
    initialPartialPayment: "Initial Partial Payment",
    orderStatus: "Order Status",
    comment: "Comment",
    currentStatus: "Current Status",
    paymentStatus: "Payment Status",
    purchaseMethod: "Purchase Method",
    carrier: "Carrier",
    orderPrice: "Order Price",
    createdAt: "Created At",
    updatedAt: "Updated At",
    courierReceiptNo: "Courier Receipt No",
    reorderNumber: "Reorder Number",
    refundReceiptNo: "Refund Receipt No",
    refundCode: "Refund Code",
    refundReceipt: "Refund Receipt",
    lengthMeasurementUnit: "Length Unit",
    weightMeasurementUnit: "Weight Unit"
  },
  
  // Placeholders
  placeholders: {
    searchOrders: "Search orders...",
    selectCustomer: "Select Customer",
    enterMerchantName: "Enter merchant name",
    enterDescription: "Color, Size, any instructions",
    enterQuantity: "Enter quantity",
    enterWeight: "Enter weight (LB)",
    enterWidth: "Enter width (Inch)",
    enterHeight: "Enter height (Inch)",
    enterLength: "Enter length (Inch)",
    enterTrackingId: "Enter tracking ID",
    enterLink: "Enter product link",
    enterExtendedDescription: "Enter extended description",
    selectOriginCountry: "Select Origin Country",
    selectDestinationCountry: "Select Destination Country",
    selectPaymentType: "Select Payment Type",
    selectCategory: "Select Category",
    selectShippingCompany: "Select Shipping Company",
    enterLbPrice: "Enter price per LB",
    enterComment: "Enter comment",
    enterItemPrice: "Enter item price",
    enterDgFees: "Enter DG fees",
    selectCity: "Select City",
    enterLocalDeliveryFee: "Enter local delivery fee",
    selectCurrency: "Select Currency",
    selectPurchaseMethod: "Select Purchase Method",
    enterMerchantDeliveryFee: "Enter merchant delivery fee",
    selectLengthUnit: "Select Length Unit",
    selectWeightUnit: "Select Weight Unit",
    enterInitialPartialPayment: "Enter initial partial payment amount",
    enterAdditionalCost: "Enter additional cost"
  },
  
  // Status options
  statusOptions: {
    0: "Pending",
    1: "Validated",
    2: "Rejected",
    3: "Valid For Shipping",
    4: "Rejected By Shipping",
    5: "Calculated",
    6: "Approved",
    7: "Approved By Customer",
    8: "Rejected By Customer",
    9: "Payment Under Collecting",
    10: "Purchase Under Process",
    11: "On Hold",
    12: "Cancelled",
    13: "Order Purchased",
    14: "In Transit To Origin Warehouse",
    15: "Received At Origin Warehouse",
    16: "Lost/Damaged",
    17: "Delayed",
    18: "Refunded",
    19: "Reordered",
    20: "Shipped",
    21: "Arrived at Destination Country",
    22: "Under Customs Clearance",
    23: "Released From Customs",
    24: "Out For Delivery",
    25: "Delivered",
    26: "Delivery Failed",
    27: "Out For Delivery (Rescheduled)",
    28: "Returned To Sender",
    29: "Cancelled By Seller",
    30: "Refund Under Process",
    31: "Waiting To Receive Shipment",
    unknown: "Unknown Status"
  },

  // Payment type options
  paymentTypes: {
    0: "Cash on Delivery",
    1: "Partial Payment",
    2: "Advance Payment"
  },

  // Item type options
  itemTypes: {
    0: "Normal",
    1: "Dangerous"
  },

  // Delivery mode options
  deliveryModes: {
    0: "Economy",
    1: "Fast"
  },

  // Refund type options
  refundTypes: {
    0: "Please Select",
    1: "Cash",
    2: "Voucher"
  },

  // Extra field labels
  extraFieldLabels: {
    courierReceiptNo: "Courier Receipt No",
    orderNumber: "Order Number",
    shippingOrderNo: "Shipping Order No",
    reorderNumber: "Reorder Number",
    refundReceiptNo: "Refund Receipt No"
  },

  // Messages
  messages: {
    createSuccess: "Order created successfully",
    createError: "Failed to create order",
    updateSuccess: "Order updated successfully",
    updateError: "Failed to update order",
    deleteSuccess: "Order deleted successfully",
    deleteError: "Failed to delete order",
    deleteConfirm: "Are you sure you want to delete this order?",
    statusUpdateSuccess: "Order status updated successfully",
    statusUpdateError: "Failed to update order status",
    noOrders: "No orders found",
    loadingOrders: "Loading orders...",
    loading: "Loading order details...",
    fetchError: "Failed to fetch orders",
    orderNotFound: "Order not found",
    noInvoices: "No invoices found.",
    noLogs: "No Logs found.",
    rejectedShipping: "Order has been rejected due to shipping reasons",
    rejected: "Order has been rejected",
    orderReset: "Order has been reset successfully",
    resetFailed: "Failed to reset order"
  },
  
  // Actions
  actions: {
    view: "View",
    edit: "Edit",
    delete: "Delete",
    print: "Print",
    reset: "Reset",
    updateStatus: "Update Status",
    back: "Back to Orders",
    save: "Save Changes",
    cancel: "Cancel",
    refresh: "Refresh",
    validateOrder: "Validate Order",
    invalidateOrder: "Invalidate/Cancel Order",
    updateOrder: "Update Order",
    calculating: "Calculating...",
    calculateOrder: "Calculate Order",
    calculate: "Calculate Order",
    resetOrder: "Reset Order",
    updating: "Updating...",
    confirm: "Confirm",
    saveStatus: "Save Status",
    addNewInvoice: "Add New Invoice",
    virtualPartialCalculation: "Virtual Partial Calculation",
    partialPaymentValidationCalculation: "Partial Payment Validation & Calculation",
    applying: "Applying...",
    processing: "Processing...",
    apply: "Apply"
  },

  calculator: {
    title: "Order Shipping Calculator",
    subtitle: "Calculate shipping costs for Buy4Me orders"
  },

  // Table headers
  table: {
    orderNumber: "Order #",
    group: "Group",
    customer: "Customer",
    merchantName: "Merchant",
    quantity: "Qty",
    status: "Status",
    netPrice: "Net Price",
    actions: "Actions",
    no: "No",
    amountFC: "Amount FC",
    amountIQD: "Amount IQD",
    collectionDate: "Collection Date",
    collected: "Collected?",
    received: "Received?",
    courierReceiptNo: "Courier Receipt No",
    paymentGateway: "Payment Gateway",
    user: "User",
    actionDate: "Action Date",
    log: "Log"
  },
  
  // Breadcrumbs
  breadcrumbs: {
    orders: "Orders",
    create: "Create Order",
    edit: "Edit Order",
    view: "Order Details"
  },
  
  // Sections
  sections: {
    merchantDetails: "Merchant Details",
    orderInfo: "Order Information",
    dimensions: "Dimensions",
    shippingTracking: "Shipping & Tracking",
    pricing: "Pricing Details",
    customerInfo: "Customer Information",
    orderHistory: "Order History",
    statusHistory: "Status History",
    refundDetails: "Refund Details",
    productInformation: "Product Information",
    pricingQuantity: "Pricing & Quantity",
    locationShipping: "Location & Shipping",
    dimensionsWeight: "Dimensions & Weight",
    shippingOptions: "Shipping Options",
    extraInformation: "Extra Information"
  },

  // Summary section
  summary: {
    exchangePrice: "Exchange Price",
    choosenWeight: "Choosen Weight",
    shippingCost: "Shipping Cost",
    shippingInsurance: "Shipping Insurance",
    fuelCost: "Fuel Cost",
    tax: "Tax",
    additionalCost: "Additional Cost",
    discount: "Discount",
    servicePrice: "Service Price",
    netPrice: "Net Price",
    orderPrice: "Order Price",
    totalPrice: "Total Price",
    buyForMeCost: "Buy For Me Cost",
    paymentMethodFee: "Payment Method Fee",
    summaries: "Shipping & Payment Summary",
    total: "Total",
    locked: "Locked",
    fxLockTitle: "Locked Exchange Rate (at payment)",
    lockedRate: "USD/IQD Rate",
    rateSource: "Rate Source",
    lockedAt: "Locked At",
    roundingRule: "Rounding Rule"
  },
  
  // Units
  units: {
    lb: "LB",
    inch: "Inch",
    usd: "USD",
    iqd: "IQD"
  },
  
  // Validation
  validation: {
    linkRequired: "Link is required",
    linkInvalid: "Please enter a valid URL",
    merchantNameRequired: "Merchant name is required",
    merchantNameMinLength: "Merchant name must be at least 2 characters",
    descriptionRequired: "Item description is required",
    descriptionMinLength: "Description must be at least 3 characters",
    quantityRequired: "Quantity must be greater than 0",
    quantityMin: "Quantity must be at least 1",
    quantityMax: "Quantity cannot exceed 1000",
    itemPriceRequired: "Item price must be greater than 0",
    itemPriceMax: "Item price is too high",
    currencyRequired: "Please select a currency",
    weightRequired: "Weight must be greater than 0",
    weightMax: "Weight cannot exceed 1000 kg",
    widthRequired: "Width must be greater than 0",
    widthMax: "Width cannot exceed 1000 cm",
    heightRequired: "Height must be greater than 0",
    heightMax: "Height cannot exceed 1000 cm",
    lengthRequired: "Length must be greater than 0",
    lengthMax: "Length cannot exceed 1000 cm",
    dimensionsRequired: "Dimensions are required",
    originCountryRequired: "Please select origin country",
    destinationCountryRequired: "Please select destination country",
    categoryRequired: "Please select a category",
    shippingCompanyRequired: "Please select shipping company",
    paymentMethodRequired: "Please select payment method",
    pricePerLBRequired: "Price per LB is required when enabled",
    deliveryFeeInvalid: "Delivery fee cannot be negative",
    shippingMethodRequired: "Shipping method is required",
    cityRequired: "Please select a city",
    paymentTypeRequired: "Please select payment type",
    merchantDeliveryFeeRequired: "Merchant delivery fee is required",
    allFieldsRequired: "All fields are required",
    required: "Required"
  },

  // Modal translations
  modal: {
    confirmStatusChange: "Confirm Status Change",
    yesChange: "Yes, Change"
  },

  // Voucher approval translations
  voucherApproval: {
    title: "Voucher Refund Approval Required",
    message: "Do you confirm sending voucher to the customer with amount",
    approve: "Yes, Send Voucher",
    cancel: "Cancel",
    partialPaymentNote: "This amount represents the initial partial payment made by the customer."
  },

  common: {
    notCollected: "Not Collected",
    collected: "Collected",
    received: "Received",
    notReceived: "Not Received",
    no: "No",
    yes: "Yes"
  },

  // Customer Actions (Admin performing actions on behalf of customer)
  customerActions: {
    title: "Customer Actions (Admin)",
    description: "This order is awaiting customer approval. You can perform these actions on behalf of the customer.",
    applyVoucher: "Apply Voucher",
    voucherCode: "Voucher Code",
    enterVoucherCode: "Enter voucher code",
    voucherRequired: "Please enter a voucher code",
    voucherApplied: "Voucher applied successfully",
    voucherAppliedAmount: "Voucher Applied",
    voucherFailed: "Failed to apply voucher",
    approveReject: "Approve or Reject Order",
    approveRejectDescription: "Click one of the buttons below to approve or reject this order on behalf of the customer.",
    approve: "Approve Order",
    reject: "Reject Order",
    orderApproved: "Order approved on behalf of customer",
    orderRejected: "Order rejected on behalf of customer",
    statusChangeFailed: "Failed to change status"
  }
};
